import React from 'react'
//import PersonIcon from '@material-ui/icons/PersonPinIcon';
import { Link } from 'react-router-dom'
import SocialFeedCard from '../components/SocialFeedCard'


export default function SocialFeed() {
    const feed = [
        {   
            user_id:"kevin123",
            recipe: "Homemade Spaghetti",
            timestamp: "1560889461130"
        },
        {   
            user_id:"adam456",
            recipe: "Mac and Cheese",
            timestamp: "1160889461130"
        },
        {   
            user_id:"yigit789",
            recipe: "Chicken Breast Platter",
            timestamp: "1222889461130"
        }]

    return (
        <div className='SocialFeed'>
            { feed.map( item => <SocialFeedCard user_id={item.user_id} recipe_name={item.recipe} timestamp={item.timestamp}/>) }

        </div>
    )
}
